module.exports = __webpack_public_path__ + "img/franc-sign.41abf917.svg";